import { Link } from "react-router-dom";
import wordmarkSvg from "@/assets/wordmark.svg";
import logoSvg from "@/assets/logo.svg";

const LandingFooter = () => (
  <footer className="py-12 bg-card/40 border-t border-border/40 backdrop-blur-xl">
    <div className="container mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-2 opacity-80">
        <img src={logoSvg} alt="" className="h-5 w-5 rounded" />
        <img src={wordmarkSvg} alt="HeirWise wordmark" className="h-4" />
      </div>
      <div className="flex flex-col items-center gap-2 md:items-end">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 md:justify-end">
          <Link to="/privacy-policy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            Terms of Service
          </Link>
          <Link to="/children-privacy-notice" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            Teen Privacy
          </Link>
          <Link to="/data-deletion-request" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            Data Requests
          </Link>
          <a href="mailto:founder@steenventures.com" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            founder@steenventures.com
          </a>
        </div>
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} HeirWise. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default LandingFooter;
